import React from "react";

import { twJoin } from "tailwind-merge";

type ErrorHintProps = {
  // we only allow certain values so we can ensure these classes are in the tailwind bundle.
  height?: "h-2" | "h-2.5";
  className?: string;
  children: React.ReactNode;
  margin?: "md" | "none";
  dataLoc?: string;
};

export const ErrorHint: React.FC<ErrorHintProps> = ({
  height,
  className,
  children,
  margin = "md",
  dataLoc = "error-hint",
}) => {
  return (
    <p
      className={twJoin(
        `font-inter-normal-12px text-red-600`,
        margin === "md" && "mb-2",
        height,
        className,
      )}
      data-loc={dataLoc}
    >
      {children}
    </p>
  );
};
